module.exports = "/img/chevrolet.246139db.png";